document.addEventListener("DOMContentLoaded", () => {
  const stickyATC = document.querySelector("[data-sticky-atc]");
  const productInfo = document.querySelector("product-info");
  const mainProductInfo = document.querySelector("product-info");
  const sectionId = mainProductInfo?.getAttribute("data-section");
  const stickyProductForm = document.querySelector(`#product-form-sticky-${sectionId}`);
  const mainProductForm = document.querySelector('form[data-type="add-to-cart-form"]');
  const mainProductPrice = document.querySelector(`#price-${sectionId}`);
  const stickyProductPrice = document.querySelector(`#price-sticky-${sectionId}`);
  const stickyVariantDisplay = document.querySelector("[data-sticky-atc-variant]");
  const qtyInput = document.querySelector(".quantity-input");
  const minusBtn = document.querySelector(".qty-minus");
  const plusBtn = document.querySelector(".qty-plus");

  if (!stickyATC || !productInfo) return;

  // Show/hide sticky ATC bar
  new IntersectionObserver(([entry]) => {
    stickyATC.classList.toggle("is-shown", !entry.isIntersecting);
    stickyATC.hidden = entry.isIntersecting;
    document.body.style = `--sticky-atc-height: ${stickyATC.offsetHeight}px`;
  }, { threshold: 0.1 }).observe(productInfo);

  // Quantity +/- logic
  if (qtyInput && minusBtn && plusBtn) {
    minusBtn.addEventListener("click", () => {
      const current = parseInt(qtyInput.value);
      const min = parseInt(qtyInput.dataset.min) || 1;
      if (current > min) {
        qtyInput.value = current - 1;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    plusBtn.addEventListener("click", () => {
      const current = parseInt(qtyInput.value);
      const step = parseInt(qtyInput.step) || 1;
      const max = qtyInput.dataset.max ? parseInt(qtyInput.dataset.max) : null;

      if (!max || current < max) {
        qtyInput.value = current + step;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // Scroll to main product info when sticky variant text clicked
  stickyVariantDisplay?.addEventListener("click", () => {
    mainProductInfo?.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  if (!mainProductForm || !stickyProductForm || !sectionId) return;

  const stickyVariantInput = stickyProductForm.querySelector('input[name="id"]');
  const mainSubmitButton = document.querySelector(`#ProductSubmitButton-${sectionId}`);
  const stickySubmitButton = stickyProductForm.querySelector('.product-form__submit');

  const updateVariantDisplay = () => {
    try {
      const variantData = JSON.parse(document.querySelector('script[data-selected-variant]')?.textContent || '{}');
      if (variantData?.title && stickyVariantDisplay) {
        stickyVariantDisplay.textContent = variantData.title;
      }
    } catch (err) {
      console.warn("Error parsing variant data:", err);
    }
  };

  const syncStickyATC = (variantId) => {
    if (stickyVariantInput) stickyVariantInput.value = variantId;

    // Sync display
    updateVariantDisplay();

    // Sync price
    if (mainProductPrice && stickyProductPrice) {
      stickyProductPrice.innerHTML = mainProductPrice.innerHTML;
    }

    // Sync button
    if (mainSubmitButton && stickySubmitButton) {
      stickySubmitButton.disabled = mainSubmitButton.disabled;
      const mainText = mainSubmitButton.querySelector("span")?.textContent;
      const stickyText = stickySubmitButton.querySelector("span");
      if (stickyText && mainText) {
        stickyText.textContent = mainText;
      }
    }
  };

  // Sync quantity between main form and sticky form
  const mainQuantityInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="quantity"]');
  const stickyQuantityInput = document.querySelector('.sticky-atc-bar input[name="quantity"]');

  if (mainQuantityInput && stickyQuantityInput) {
    // Initial sync
    stickyQuantityInput.value = mainQuantityInput.value;

    // Sync from main to sticky
    mainQuantityInput.addEventListener('change', () => {
      stickyQuantityInput.value = mainQuantityInput.value;
    });

    // Sync from sticky to main
    stickyQuantityInput.addEventListener('change', () => {
      mainQuantityInput.value = stickyQuantityInput.value;
    });
  }

  // Watch for changes on variant inputs
  const handleVariantChange = (e) => {
    const variantId = e.target.value;
    // Debounce update slightly
    setTimeout(() => syncStickyATC(variantId), 50);
  };

  // Bind variant ID input
  document.querySelectorAll('input[name="id"]').forEach(input => {
    input.addEventListener("change", handleVariantChange);
  });

  // Initial sync on load
  const initialVariant = document.querySelector('input[name="id"]')?.value;
  if (initialVariant) syncStickyATC(initialVariant);
});
